import './CopTable.scss';

import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid'

export type SiteColumnTitles = {
  city?: string
  country?: string
  customerSiteName?: string
  geolocation?: string
  name?: string
  operationalStatus?: string
  operator?: string
  owner?: string
  view?: string
  id?:string
}

const toD = (val: string | undefined, isLat: boolean): string => {
  const num = Number.parseFloat(val ?? '');
  if (Number.isNaN(num)) return '—';
  const abs = Math.abs(num);
  const deg = Math.floor(abs);
  const minFull = (abs - deg) * 60;
  const min = Math.floor(minFull);
  const sec = Math.round((minFull - min) * 60);
  const latDir = num >= 0 ? 'N' : 'S';
  const lonDir = num >= 0 ? 'E' : 'W';
  const dir = isLat ? latDir : lonDir;
  return `${deg}º ${min}' ${sec}" ${dir}`;
};

const getDetailUrl = (id: string, viewPageUrl?: string) => {
  if (viewPageUrl) return `${viewPageUrl}/${id}`
  const basePath = window.location.pathname.replace(/\/[^/]*$/, '')
  return `${window.location.origin}${basePath}/site-details/${id}`
}

const SiteLink = ({ value, id, viewPageUrl }: { value: string; id: string; viewPageUrl?: string }) => (
  <a href={getDetailUrl(id, viewPageUrl)} className="cop-site-link">
    {value}
  </a>
);

const ViewButton = ({ id, viewPageUrl }: { id: string; viewPageUrl?: string }) => (
  <button
    className="cop-view-button"
    onClick={() => { window.location.href = getDetailUrl(id, viewPageUrl); }}
  >
    View
  </button>
);

export function getSiteColumns(
  columnTitles: SiteColumnTitles = {},
  viewPageUrl?: string,
  canViewSiteDetails?: boolean,
): GridColDef[] {
  return [
    {
      field: 'name',
      headerName: columnTitles.name ?? 'Site Name',
      flex: 1,
      minWidth: 180,
      filterable:false,
      renderCell: (params: GridRenderCellParams) => <SiteLink value={params.value} id={String(params.row.id)} viewPageUrl={viewPageUrl} />,
    },
    {
      field: 'customerSiteName',
      headerName: columnTitles.customerSiteName ?? 'Customer Site Name',
      flex: 1,
      minWidth: 180,
      filterable:false,
    },
    {
      field: 'city',
      headerName: columnTitles.city ?? 'City',
      flex: 0.8,
      minWidth: 130,
      filterable:false,
    },
    {
      field: 'country',
      headerName: columnTitles.country ?? 'Country',
      flex: 0.8,
      minWidth: 130,
      filterable:false,
    },
    {
      field: 'operationalStatus',
      headerName: columnTitles.operationalStatus ?? 'Site Status',
      flex: 0.8,
      minWidth: 150,
      filterable:false,
    },
    {
      field: 'operator',
      headerName: columnTitles.operator ?? 'Operator',
      flex: 0.8,
      minWidth: 130,
      filterable:false,
    },
    {
      field: 'owner',
      headerName: columnTitles.owner ?? 'Owner',
      flex: 0.8,
      minWidth: 130,
      filterable:false,
    },
    {
      field: 'id',
      headerName: columnTitles.id ?? 'Site ID',
      flex: 0.8,
      minWidth: 130,
      filterable:false,
    },

    {
      field: 'geolocation',
      headerName: columnTitles.geolocation ?? 'Geolocation',
      flex: 1,
      minWidth: 220,
      sortable: false,
      filterable:false,
      renderCell: (params: GridRenderCellParams) => (
        <span>{toD(String(params.row.latitude), true)} and {toD(String(params.row.longitude), false)}</span>
      ),
    },
    ...(canViewSiteDetails ? [{
      field: 'actions',
      headerName: columnTitles.view ?? '',
      flex: 0.5,
      minWidth: 130,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params: GridRenderCellParams) => <ViewButton id={String(params.row.id)} viewPageUrl={viewPageUrl} />,
    }] : []),
  ]
}
